<template>
	<div class="not_found">
		<vue-headful
				description=""
				title="Slumberland : 404"
		/>
		<h1>404 - Page introuvable</h1>
		<p class="text-center">
			Nous sommes désolés, cette page n'est pas disponible.
		</p>
		<p class="text-center">
			<router-link :to="{ name: 'Réalisations'}">
				Retour à la liste de nos réalisations
				<font-awesome-icon :icon="['far', 'arrow-right']"/>
			</router-link>
		</p>
		<p class="text-center">
			<router-link :to="{ name: 'L’agence'}">
				Découvrir l'agence
				<font-awesome-icon :icon="['far', 'arrow-right']"/>
			</router-link>
		</p>
	</div>
</template>

<script>

export default {
	name: "NotFound"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@use '@/assets/scss/partials/variables' as *;
@use '@/assets/scss/partials/mixins' as *;

.not_found {
	align-items: center;
	display: flex;
	flex-direction: column;
	justify-content: center;

	h1 {
		display: inline-block;
		font-family: $IsidoraBold;
		font-size: 4rem;
		font-size: 4rem;
		margin-bottom: 4rem;
		position: relative;

		&:after {
			background-color: $black;
			bottom: -1.5rem;
			content: '';
			height: 0.4rem;
			left: 50%;
			position: absolute;
			transform: translateX(-50%);
			width: 8rem;
		}
	}

	p {
		width: auto;

		a {
			svg {
				padding-left: 1rem;
			}
		}
	}
}

</style>
